const DOMAIN = process.env.REACT_APP_DOMAIN;
const PROTOCOL = DOMAIN === "local.com" ? "http" : "https";

const config = {
  DOMAIN,
  PROTOCOL,
  API_HOST: `${PROTOCOL}://app.${DOMAIN}`,
  RESOURCE_ORIGIN: `${PROTOCOL}://assets.${DOMAIN || "alphacat.app"}`,
  INTERCOM_APP_ID: process.env.REACT_APP_INTERCOM_APP_ID,
  AMPLITUDE_API_KEY: process.env.REACT_APP_AMPLITUDE_API_KEY,
};

export default config;
